/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Password_RequiredInputs */

const en_mobile_password_required = /** @type {(inputs: Mobile_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please, enter your password`)
};

const es_mobile_password_required = /** @type {(inputs: Mobile_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu contraseña`)
};

/**
* | output |
* | --- |
* | "Please, enter your password" |
*
* @param {Mobile_Password_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_password_required = /** @type {((inputs?: Mobile_Password_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Password_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_password_required(inputs)
	return en_mobile_password_required(inputs)
});